/** Téléphone/tablette probable : pointeur tactile ET petit écran. */
export function isLikelyMobile() {
    try {
        return (
            window.matchMedia('(pointer: coarse)').matches && Math.min(window.screen.width, window.screen.height) < 768
        );
    } catch {
        return false;
    }
}
